export default $axios => ({
    getSimilarProductsList(id) {
        return $axios({
            method: 'GET',
            url: `/general/product_similar_products?product_id=${id}`,
        });
    },
    getProduct(slug) {
        return $axios({
            method: 'GET',
            url: `/general/v2/product/${slug}`,
        });
    },
    getProductProperties(id) {
        return $axios({
            method: 'GET',
            url: `/general/product_properties?product_id=${id}`,
        });
    },
    getProductReviews(id) {
        return $axios({
            method: 'GET',
            url: `/general/product-review/?product_id=${id}&timestamp=${Date.now()}`,
        });
    },
    getProductAdvantages() {
        return $axios({
            method: 'GET',
            url: `/base/advantage/product_page`,
        });
    },
    postProductReview(data) {
        return $axios({
            method: 'POST',
            url: `/general/product-review/`,
            data: data,
        });
    },
    postReviewLike(id) {
        return $axios({
            method: 'POST',
            url: `/general/product-review/${id}/like/`,
        });
    },
    postReviewDislike(id) {
        return $axios({
            method: 'POST',
            url: `/general/product-review/${id}/dislike/`,
        });
    },
});
